/**
 * Checks if the current URL is using localhost or 127.0.0.1
 * @returns true if the URL is using localhost or 127.0.0.1, false otherwise
 */
export function isLocalhost(): boolean {
  const hostname = window.location.hostname
  return hostname === 'localhost' || hostname === '127.0.0.1'
}

/**
 * Determines if MSAL should be enabled based on environment and hostname
 * MSAL should be disabled only when in development and accessing via non-localhost URL
 * @returns true if MSAL should be enabled, false otherwise
 */
export function shouldEnableMsal(): boolean {
  const hostname = window.location.hostname
  const isLocalhostAccess = hostname === 'localhost' || hostname === '127.0.0.1'

  // In development, only enable MSAL when accessing via localhost
  if (import.meta.env.DEV) {
    return isLocalhostAccess
  }

  // In production, always enable MSAL
  return true
}
